var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2188 15.2344V27.4219H32.0625C32.2198 27.4223 32.3706 27.4867 32.4818 27.6009C32.5931 27.7151 32.6558 27.8698 32.6562 28.0312V37.1719C32.6558 37.3333 32.5931 37.4881 32.4818 37.6023C32.3706 37.7164 32.2198 37.7808 32.0625 37.7812H5.9375C5.78017 37.7808 5.62941 37.7164 5.51816 37.6023C5.40691 37.4881 5.3442 37.3333 5.34375 37.1719V10.3594C5.3449 10.1978 5.40656 10.0429 5.51594 9.92672L13.8284 1.39547C13.9416 1.28321 14.0926 1.21993 14.25 1.21875H32.0625C32.2198 1.21922 32.3706 1.28357 32.4818 1.39775C32.5931 1.51193 32.6558 1.66665 32.6562 1.82812V14.625C32.6558 14.7865 32.5931 14.9412 32.4818 15.0554C32.3706 15.1696 32.2198 15.2339 32.0625 15.2344H17.2188Z",
    fill: "#D6E0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0625 14.0156H9.5C9.17208 14.0156 8.90625 14.2885 8.90625 14.625V28.0312C8.90625 28.3678 9.17208 28.6406 9.5 28.6406H32.0625C32.3904 28.6406 32.6562 28.3678 32.6562 28.0312V14.625C32.6562 14.2885 32.3904 14.0156 32.0625 14.0156Z",
    fill: "#D6E0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8438 1.21875V10.3594C14.8433 10.5208 14.7806 10.6756 14.6693 10.7898C14.5581 10.9039 14.4073 10.9683 14.25 10.9688H5.34375V10.3594C5.3449 10.1978 5.40656 10.0429 5.51594 9.92672L13.8284 1.39547C13.9416 1.28321 14.0926 1.21993 14.25 1.21875H14.8438Z",
    fill: "#8D93AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf-file.c9a5b6d5cd7a57d63d0fb17cc0c35436.svg";
export { ForwardRef as ReactComponent };